<template>
  <div class="content-table">
    <div class="content-center-row" style="margin-top:1.5%"> 
        <div class="left-menu inline-div ">
            <div 
              v-for="(item,index) in zone_data"
              :key="index"
              class="good_div"
            >
              <div class="content-center-row">
                <div class="demo-image__preview" style="height: 178px;" @click="buyGood(item.id)">
                  <el-image
                    v-if="item.pic!='' && item.pic!= null"
                    :src="item.pic"
                    style="height: 100%;width: 100%;"
                  ></el-image>
                  <el-image v-else src="static/image/error.png" style="height: 100%;width: 100%;"></el-image>
                </div>
              </div>
              <div class="content-left-row f-14-gray hides">
                <span class="span-price" style="float:left">￥{{item.sale_price}}</span>
                <span style="float:right;color:#000">{{item.stock_num}}&nbsp;&nbsp;{{item.good_unit_itemid}}</span>
              </div>
              <div class="content-left-row good_name_sty">
                <span
                  :title="item.good_spec"
                  style="width:90%;white-space:pre-wrap;height: 15px;overflow: hidden;color: #000;"
                >{{item.good_spec}}</span>
              </div>
              <div
                class="content-left-row f-14-gray hides good_name_sty"
                style="color: #000000;font-size:12px"
              >
                <span
                  :title="item.good_name"
                  style="float:left"
                >{{item.good_name}}|{{item.brand_id}}</span>
              </div>
              <div class="content-row seven-row">
                <el-button
                  class="col-4"
                  style="font-size:13px;padding: 7px 3px;"
                  :type="item.is_collect == 1 ? 'primary' : 'button'"
                  size="mini"
                  plain
                  @click="collectionGood(item.is_collect, item.good_itemid)"
                >
                  <i class="fa fa-heart" aria-hidden="true"></i>
                  {{item.is_collect == 1 ? '已收藏' : '收藏'}}
                </el-button>
                <el-button
                  type="danger"
                  @click="buyGood(item.id)"
                  size="mini"
                  plain
                  class="col-7"
                  style="font-size: 13px;"
                >
                  <i class="fa fa-shopping-cart" aria-hidden="true"></i>
                  <span>加入购物车</span>
                </el-button>
              </div>
            </div>
        </div> 
    </div>
  </div>
</template> 
<script>
import footer from "@/components/footer/index";
export default {
  components: { footer },
  data() {
    return {
      recently_list: [],
      hot_list: [],
      promotion_list: [],
      notice_data: [],
      mation_data: [],
      notice_hide: true,
      mation_hide: false,
      login_user: {},
      show_name: "",
      prom_list: [],
      good_zone: [],
      zone_data: [],
      pages: [
        {
          title: "slide3",
          url: "static/image/custBanner.png"
        },
        {
          title: "slide3",
          url: "static/image/lunbo.png"
        }
      ]
    };
  },
  watch: {},
  mounted() {
    this.view();
  },
  methods: {
    view() {
      var ids = this.$route.query.id;
      this.$axios({
        method: "post",
        url: "/index/catalogue/area_goods",
        params: {
          page: 1,
          pagesize: 99999,
          id: ids
        }
      })
        .then(res => {
          this.zone_data = res.data.data;
        })
        .catch(err => {});
    },
    notice_detail(status, item) {
      this.$router.push({
        path: "/Customized/index",
        query: { status: status, item: item }
      });
    },
    collectionGood(collect, good_erpid) {
      if (collect == 1) {
        this.$axios({
          method: "post",
          url: "/index/collection/del",
          params: {
            good_erpid: good_erpid
          }
        })
          .then(res => {
            if (res.data.status == "ok") {
              this.$message1("取消收藏成功!");
              this.view();
            }
          })
          .catch(err => {
            // this.$message(res.data.msg);
          });
      } else {
        this.$axios({
          method: "post",
          url: "/index/Collection/create",
          params: {
            id: good_erpid
          }
        })
          .then(res => {
            if (res.data.status == "ok") {
              this.$message1(res.data.msg);
              this.view();
            }
          })
          .catch(err => {
            // this.$message(res.data.msg);
          });
      }
      this.getGoodList();
    },

    // 我的收藏
    collection() {
      this.$router.replace({
        path: "/Personal/index",
        query: { page_name: "我的订单", menu_id: 1 }
      });
    },

    detail() {
      this.$router.push({
        path: "/Detail/index"
      });
    },
    notice() {
      this.mation_hide = false;
      $(".div_left > span")
        .eq(1)
        .removeClass("color");
      $(".div_left > span")
        .eq(0)
        .addClass("color");
      this.notice_hide = true;
    },
    mation() {
      this.mation_hide = true;
      this.notice_hide = false;
      $(".div_left > span")
        .eq(0)
        .removeClass("color");
      $(".div_left > span")
        .eq(1)
        .addClass("color");
    },
    buyGood(good_id) {
      if (good_id != "") {
        this.$router.push({
          path: "/GoodDetail/index",
          query: { id: good_id }
        });
      }
    }
  }
};
</script>
<style lang="less" scoped>
body {
  overflow-y: auto;
}
.center-near-row {
  background-image: url("/static/image/center-bg.png");
}
.center-promotion-row {
  background-color: #f9f5f0;
}
.center-hot-row {
  background-color: #edf1f5;
}
.center-near-row,
.center-promotion-row,
.center-hot-row {
  margin-bottom: 0;
}
.span-white {
  color: #fff;
}
.recent-left-img {
  float: left;
  margin-left: 18.5%;
  width: 13%;
}
.recent-list-div {
  border: 1px solid lightgray;
  background-color: #fff;
  float: left;
  width: 18%;
  height: 50%;
  margin: 0 0.5% 1% 0.5%;
  padding: 0.5%;
}
.prom-list-div {
  border: 1px solid lightgray;
  background-color: #fff;
  float: left;
  width: 15.5%;
  height: 50%;
  margin: 0 1% 1% 1%;
  padding: 1%;
}
.recent-all-list {
  height: 100%;
  width: 50%;
  float: left;
  margin-left: 1%;
}
.div-recent {
  margin: 1% 0 1% 0;
}
.auto-fix-button {
}
.content-left-row {
  margin-bottom: 5%;
}
.top-image {
  // margin-right: 1%;
  cursor: pointer;
}
.five_pic {
  width: 19%;
}
.content-center-row {
  text-align: left;
}
.el-divider--horizontal {
  margin: 16px 0;
}
// 右侧登陆div
.sign_big_div {
  min-width: 210px;
  position: absolute;
  width: 13%;
  height: 250px;
  z-index: 2;
  top: 1%;
  right: 17%;
  text-align: center;
}
.div_left {
  text-align: left;
}
.sign_div {
  background: #fff;
  padding-top: 4%;
  padding-bottom: 4%;
}
.notice {
  margin: 8px;
  border-radius: 3px;
  padding: 2px;
  border: 1px solid red;
  color: red;
  font-size: 12px;
}
.hides {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
}
.hide {
  height: 25px;
  line-height: 25px;
  font-size: 14px;
  text-align: left;
  margin-left: 8%;
}
.content-left-row {
  margin-bottom: 0%;
}
.prom_title_eng {
  font-size: 18px;
  color: rgba(211, 20, 10, 1);
}
.prom_title_chinese {
  font-size: 16px;
  color: rgba(102, 102, 102, 1);
}
.small_eng {
  font-size: 12px;
  color: rgba(102, 102, 102, 1);
  opacity: 0.6;
}
.color {
  color: #0068d3;
}
.line {
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
}
.fixed_btn {
  position: fixed;
  width: 3%;
  height: 250px;
  z-index: 2;
  top: 25%;
  right: 4%;
  text-align: center;
  margin: 4% 0;
  background: #000;
  opacity: 0.5;
}
.user_name {
  color: rgb(195, 154, 88);
  font-weight: 500;
}
.inline-div{
  display: flex;
  flex-wrap: wrap;
  .good_div{
    margin-right: 7px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/HomePage/good_zone.vue